'use strict';
import React, { Component, PropTypes } from 'react';
import { FormatMessage } from 'react-globalize';


class SectionBarri extends Component {

  constructor(props) {
    super(props);

    var imgPath;

    if (this.props.locale == 'es')
      imgPath = 'img/icons/bfgIconInsurance.png';
    else
      imgPath = "img/icons/bfgIconInsurance_en.png";

    this.state = {
      img: imgPath

    };

  }

  componentWillReceiveProps(nextProps) {

    if (!(this.props.locale == nextProps.locale)) {
      var imgPath;
      if (nextProps.locale == 'es') {

        imgPath = 'img/icons/bfgIconInsurance.png';
      } else {

        imgPath = "img/icons/bfgIconInsurance_en.png";
      }

      this.setState({
        img: imgPath
      });

    }
  }

  componentDidMount() {
    this.props.logPageView();
  }

  /**
   * @return {object}
   */
  render() {
    var Component = React.createClass({

      render: function () {
        var Iframe = this.props.Iframe;

        return (
          <div className="row ">
            <div className="col-lg-8 col-lg-offset-2 col-xs-10 col-xs-offset-1">
              <Iframe src={this.props.src} height={this.props.height} width={this.props.width}
                className={this.props.className} />
            </div>
          </div>
        )
      }
    });
    return (
      <section id="section1" className="content-section about-section sectionPage">
        <div className="col-lg-8 col-lg-offset-2 col-xs-10 col-xs-offset-1">
          <div className="row">
            <div className="col-xs-6 col-xs-offset-3 col-lg-4 col-lg-offset-4">
              <img className="img-responsive" src={this.state.img} />
            </div>
          </div>
          <p className="text-center"><FormatMessage locale={this.props.locale}
            path="insurancePage/insurancePageDescription1" /></p>
          <p><FormatMessage locale={this.props.locale} path="insurancePage/insurancePageDescription2" /></p>
        </div>
        <div className="row">
          <div className="col-lg-8 col-lg-offset-2 col-xs-10 col-xs-offset-1"><strong><FormatMessage
            locale={this.props.locale} path="insurancePage/insurancePageDescription3" /></strong><br /><br />
          </div>
        </div>
        <div className="row">
          <div className="col-md-8 col-md-offset-3 col-sm-9 col-sm-offset-1 col-xs-offset-1">
            <ul className="list-unstyled lists-v2">
              <li><i className="fa fa-check fa-inverse"></i><FormatMessage locale={this.props.locale}
                path="insurancePage/insurancePageList1" />
              </li>
              <li><i className="fa fa-check fa-inverse"></i><FormatMessage locale={this.props.locale}
                path="insurancePage/insurancePageList2" />
              </li>
            </ul>
            <br /><br />
          </div>
        </div>
        <div className="row">
          <div className="col-lg-8 col-lg-offset-2 col-xs-10 col-xs-offset-1">
            <ul className="list-unstyled lists-v2 ">
              <li>
                <br /><FormatMessage locale={this.props.locale}
                  path="insurancePage/insurancePageDescription4" />
              </li>
            </ul>
          </div>
          <div className="col-sm-2 col-xs-2"></div>
        </div>
        <div className="row">
          <div className="col-lg-8 col-lg-offset-2 col-xs-10 col-xs-offset-1">
            <ul className="list-unstyled lists-v2 ">
              <li>
                <br /><FormatMessage locale={this.props.locale}
                  path="insurancePage/insurancePageDescription5" />
              </li>
            </ul>
          </div>
          <div className="col-sm-2 col-xs-2"></div>
        </div>
        <div className="row">
          <div className="col-lg-8 col-lg-offset-2 col-xs-10 col-xs-offset-1">
            <ul className="list-unstyled lists-v2 ">
              <li>
                <br /><FormatMessage locale={this.props.locale}
                  path="insurancePage/insurancePageDescription6" />
              </li>
            </ul>
          </div>
          <div className="col-sm-2 col-xs-2"></div>
        </div>
        <div className="row">
          <div className="col-lg-8 col-lg-offset-2 col-xs-10 col-xs-offset-1">
            <ul className="list-unstyled lists-v2 ">
              <li>
                <br /><FormatMessage locale={this.props.locale}
                  path="insurancePage/insurancePageDescription7" />
              </li>
            </ul>
          </div>
          <div className="col-sm-2 col-xs-2"></div>
        </div>
        <div className="row">
          <div className="col-lg-8 col-lg-offset-2 col-xs-10 col-xs-offset-1">
            <ul className="list-unstyled lists-v2 ">
              <li>
                <br />
                <FormatMessage locale={this.props.locale}
                path="insurancePage/insuranceBuyOnline1" /> <a href="https://texas.clutchinsurance.com/new/quote?assignedAgency=100784-000-000" style={{textDecoration: "underline"}}><FormatMessage locale={this.props.locale}
                path="insurancePage/insuranceBuyOnlineHere" /></a> <FormatMessage locale={this.props.locale}
                path="insurancePage/insuranceBuyOnline2" />
              </li>
            </ul>
          </div>
          <div className="col-sm-2 col-xs-2"></div>
        </div>

        <div className="row">
          <div className="col-lg-8 col-lg-offset-2 col-xs-10 col-xs-offset-1">
            <ul className="list-unstyled lists-v2 ">
              <li>
                <br /><FormatMessage locale={this.props.locale}
                  path="insurancePage/insurancePageDescription8" />
              </li>
            </ul>
          </div>
          <div className="col-sm-2 col-xs-2"></div>
        </div>
        <Component Iframe='Iframe'
          src="https://2a933c88-5655-442a-88ac-2c6a86c9421b.quotes.iwantinsurance.com/welcome.aspx"
          height="550" width="1100" className="insurance-frame" />
      </section>
    )
  }

}
;

module.exports = (SectionBarri);
//module.exports = SectionBarri



// WEBPACK FOOTER //
// ./js/sectionCarInsurance.js